export const parseDataToRequest = (form, companyId) => {
  return {
    IdEmpresa: companyId,
    CodigoPDV: form.codigoPDV,
    Descricao: form.descricao,
    QtdSemCusto: form.qtdSemCusto,
    QtdMin: form.qtdMin,
    QtdMax: form.qtdMax,
    Ativo: form.ativo,
    AddItemMaisVezes: form.addMaisVezes,
    BordaTamanho: form.borda,
    Incrementar: form.incrementar,
    ControlaEmbalagem: form.controlaEmbalagem,
    CobrancaItemMaiorValor: form.cobrancaItemMaiorValor,
  };
};

export const parseChargeData = (montagem) => {
  const { AddItemMaisVezes, BordaTamanho } = montagem;
  return {
    codigoPDV: montagem.CodigoPDV,
    descricao: montagem.Descricao,
    qtdSemCusto: montagem.QtdSemCusto,
    ativo: montagem.Ativo,
    qtdMin: montagem.QtdMin,
    qtdMax: montagem.QtdMax,
    incrementar: montagem.Incrementar,
    addMaisVezes: AddItemMaisVezes === null || '' ? 'True' : AddItemMaisVezes,
    borda: BordaTamanho === null || '' ? 'False' : BordaTamanho,
    controlaEmbalagem: Boolean(+montagem.ControlaEmbalagem),
    cobrancaItemMaiorValor: !!montagem.CobrancaItemMaiorValor ?? false,
  };
};
